export default "__VITE_ASSET__MOfK4dwZ__";